var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-view"},[_c('iframe',{key:(_vm.url + "_" + _vm.count),attrs:{"id":"serviceIframe","width":"100%","height":"100%","allow":"autoplay","frameborder":"0","src":_vm.url,"name":_vm.iframeName}})])}
var staticRenderFns = []

export { render, staticRenderFns }